
'use strict'; 



var j = jQuery.noConflict() 
j(function () { 



    // NOTE: primary navigation behaviour now lives in app/site-header.js

    // click-to-play video
    // A `.elem-video` carrying `data-video` swaps its poster for the player
    // iframe on activation. Nothing is embedded until the visitor asks for it,
    // so no third-party player script loads on page view.
    // Markup comes from the ethisphere/video-poster and
    // ethisphere/video-testimonial blocks (both render role="button" tabindex="0").
    function openVideo(holder) {
      var $holder = j(holder);
      var src     = $holder.data('video');

      if (!src || $holder.hasClass('elem-video--open')) { return; }

      // The visitor already pressed play on the poster, so the player should
      // start rather than show a second play button. The click is a user
      // gesture and the iframe is granted `autoplay`, so browsers allow it
      // with sound. Only YouTube and Vimeo read the flag; anything else
      // (a direct .mp4) is left as-is.
      if (/^https:\/\/(www\.)?(youtube(-nocookie)?\.com\/embed\/|player\.vimeo\.com\/video\/)/.test(src)
          && !/[?&]autoplay=/.test(src)) {
        src += (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
      }

      // Shape the player from the poster's *natural* size, never its rendered
      // box. Posters are `loading="lazy"`, so a click landing before one decodes
      // measures 0 and the player mounts at zero height — invisible, and
      // indistinguishable from a broken embed. 16/9 covers the case where even
      // the natural size isn't known yet.
      var img   = $holder.find('img')[0];
      var ratio = (img && img.naturalWidth && img.naturalHeight)
        ? img.naturalWidth / img.naturalHeight
        : 16 / 9;

      // Fluid width + aspect-ratio rather than the px pair this used to write:
      // inline px froze the player at whatever the card measured on click and
      // never reflowed on resize, which `_global-ethics-summit.scss` had to undo
      // with `!important`. The ratio is passed as a string so jQuery doesn't
      // append `px` to it.
      var $iframe = j('<iframe>', {
        src: src,
        frameborder: 0,
        allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
        allowfullscreen: true,
        referrerpolicy: 'strict-origin-when-cross-origin'
      }).css({
        width: '100%',
        height: 'auto',
        aspectRatio: String(ratio),
        border: 0,
        display: 'block'
      });

      $holder.addClass('elem-video--open').empty().append($iframe);
      $iframe.trigger('focus');
    }

    j(document).on('click', '.elem-video[data-video]', function () {
      openVideo(this);
    });

    // Keyboard parity with the click handler — the design shipped these as
    // plain, unfocusable <div>s.
    j(document).on('keydown', '.elem-video[data-video]', function (event) {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        openVideo(this);
      }
    });

    // marquee
      j('.elem-marquee').marquee({
            duration: 18500,
            gap: 20,
            delayBeforeStart: 0,
            direction: 'left',
            duplicated: true,
            duplicateCount: 3
    });


           // partner carousel xs
    /*         j('.elem-marquee').slick({
            
            dots: false,
            arrows: false,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: false,
            pauseOnHover: false,
            autoplay: true,
            speed: 500,
             autoplaySpeed: 700,
            cssEase: 'linear',
            variableWidth: true,
            
         

          
      });*/


      // number animation

      const nspeed = 2000;

   j('.elem-number--waypoint').waypoint(function() {

     j({val: 0}).animate({val: 89}, {
      duration: nspeed,
      easing:'swing',
      step: function(now) {
        j('.elem-number--n1').text(Math.ceil(now) + "%");
      }
    });
    
     j({val: 0}).animate({val: 74}, {
      duration: nspeed,
      easing:'swing',
      step: function(now) {
        j('.elem-number--n2').text(Math.ceil(now) + "%");
      }
    });

     j({val: 0}).animate({val: 86}, {
      duration: nspeed,
      easing:'swing',
      step: function(now) {
        j('.elem-number--n3').text(Math.ceil(now) + "%");
      }
    });

       j({val: 0}).animate({val: 9}, {
      duration: nspeed,
      easing:'swing',
      step: function(now) {
        j('.elem-number--n4').text(Math.ceil(now) + "/10");
      }
    });

    // Data-driven counters — the ethisphere/count-stat block's figures.
    //
    // The four handlers above are hard-coded to the homepage's own stats and
    // would overwrite whatever an editor typed. This reads the target off the
    // element instead, so any page can drop in a stat without touching JS. Only
    // counters inside *this* waypoint container are animated, so two stat rows
    // on one page don't restart each other.
    j(this.element).find('[data-count-to]').each(function () {
      var $n     = j(this);
      var target = parseFloat($n.data('count-to'));
      var prefix = $n.data('count-prefix') || '';
      var suffix = $n.data('count-suffix') || '';

      if (isNaN(target)) { return; }

      // Waypoint fires on every crossing, and a viewport resize re-evaluates
      // offsets — without this the count restarts from zero mid-read.
      if ($n.data('counted')) { return; }
      $n.data('counted', true);

      // Whole targets count in whole numbers; a 4.5 keeps one decimal.
      var decimals = target === Math.round(target) ? 0 : 1;

      j({ val: 0 }).animate({ val: target }, {
        duration: nspeed,
        easing: 'swing',
        step: function (now) {
          $n.text(prefix + now.toFixed(decimals) + suffix);
        },
        complete: function () {
          $n.text(prefix + target.toFixed(decimals) + suffix);
        }
      });
    });

  }, { offset: '75%' });

// end
});

